import z from 'zod';
import {tradeMessageWriteSchema} from './tradeMessageWriteSchema';

export const tradeMessageDbSchema = tradeMessageWriteSchema;

export interface TradeMessageDb extends z.infer<typeof tradeMessageDbSchema> {}
